import axios from "axios";
// const OPEN_AI_KEY = process.env.REACT_APP_OPEN_AI_KEY;

// export const RequestAI = async (prompt, userPrompt) => {
//   try {
//     const response = await axios.post(
//       "https://api.openai.com/v1/chat/completions",
//       {
//         // model: "gpt-3.5-turbo-0125",
//         model: "ft:gpt-4o-mini-2024-07-18:classadia:classadia-bot:BP6yl6zt",
//         max_tokens: 200,
//         temperature: 0.7,
//         messages: [
//           {
//             role: "system",
//             content: `You are an assistant in a text editor. The current content is: ${prompt}`,
//           },
//           {
//             role: "user",
//             content: userPrompt,
//           },
//           {
//             role: "system",
//             content:
//               "You are assisting a teacher or nursery staff member working in an early education environment. The user may be writing observations, assessments, announcements, classroom updates, parent communication, event details, or translation requests. All outputs should be simple, clear, and empathetic — suitable for communication between early educators, parents, and school staff.\n\nIf the user message is unclear, off-topic, or includes invalid data, respond gently and helpfully. Add one friendly line of context that guides the user back to a relevant early childhood communication task (e.g., writing an observation, classroom update, or translation). Keep the tone warm, empathetic, and professional—appropriate for educators and caregivers.",
//           },
//           { role: "user", content: "blue" },
//           {
//             role: "assistant",
//             content:
//               "I’d love to help with that! If you’re working on a classroom message, observation, or translation, feel free to share the details so I can support you.",
//           },
//           {
//             role: "system",
//             content:
//               "You are assisting a teacher or nursery staff member working in an early education environment. The user may be writing observations, assessments, announcements, classroom updates, parent communication, event details, or translation requests. All outputs should be simple, clear, and empathetic — suitable for communication between early educators, parents, and school staff.\n\nIf the user message is unclear, off-topic, or includes invalid data, respond gently and helpfully. Add one friendly line of context that guides the user back to a relevant early childhood communication task (e.g., writing an observation, classroom update, or translation). Keep the tone warm, empathetic, and professional—appropriate for educators and caregivers.",
//           },
//           { role: "user", content: "IDK" },
//           {
//             role: "assistant",
//             content:
//               "No worries! If you’re writing an observation, classroom update, or parent message, I’m here to help—just let me know what you need.",
//           },
//         ],
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${OPEN_AI_KEY}`,
//         },
//       }
//     );
//     const generatedContent = response.data.choices[0]?.message?.content;
//     return generatedContent;
//   } catch (err) {
//     console.log(err);
//   }
//};

const AZURE_API_KEY = process.env.REACT_APP_AZURE_API_KEY;
const AZURE_ENDPOINT = process.env.REACT_APP_AZURE_ENDPOINT;
const DEPLOYMENT_NAME = process.env.REACT_APP_DEPLOYMENT_APP;
const API_VERSION = process.env.REACT_APP_API_VERSION;

export const RequestAI = async (prompt, userPrompt) => {
  const response = await axios.post(
    `${AZURE_ENDPOINT}/openai/deployments/${DEPLOYMENT_NAME}/chat/completions?api-version=${API_VERSION}`,
    {
      messages: [
        {
          role: "system",
          content: `You are assisting a teacher or nursery staff member working in an early education environment. The user may be writing observations, assessments, announcements, classroom updates, parent communication, event details, or translation requests. All outputs should be simple, clear, and empathetic — suitable for communication between early educators, parents, and school staff. If the user message is unclear, off-topic, or includes invalid data, respond gently and helpfully. Add one friendly line of context that guides the user back to a relevant early childhood communication task (e.g., writing an observation, classroom update, or translation). Keep the tone warm, empathetic, and professional—appropriate for educators and caregivers.`,
        },
        { role: "user", content: prompt },
        {
          role: "user",
          content: "blue",
        },
        {
          role: "assistant",
          content:
            "I’d love to help with that! If you’re working on a classroom message, observation, or translation, feel free to share the details so I can support you.",
        },
        {
          role: "user",
          content: "IDK",
        },
        {
          role: "assistant",
          content:
            "No worries! If you’re writing an observation, classroom update, or parent message, I’m here to help—just let me know what you need.",
        },
        {
          role: "user",
          content: userPrompt,
        },
      ],
    },
    {
      headers: {
        "api-key": AZURE_API_KEY,
        "Content-Type": "application/json",
      },
    }
  );
  // console.log("Azure Response:", response.data.choices[0].message.content);
  const generatedContent = response.data.choices[0].message.content;
  return generatedContent;
};
